// extracted by mini-css-extract-plugin
export default {"icon":"Logo_icon__n+PX2"};